import { Container, Content, Security, TextSecurity } from "./styles";
import { FaLock } from "react-icons/fa";
import logo from "../../assets/img/logo.png";

function Header() {
  return (
    <Container>
      <Content>
        <div>
          <img src={logo} alt="" />
        </div>
        <Security>
          <div>
            <p>
              <FaLock />
            </p>
          </div>
          <TextSecurity>
            <div className="100">
              <strong>100%</strong>
            </div>
            <div>
              <p>Seguro</p>
            </div>
          </TextSecurity>
        </Security>
      </Content>
    </Container>
  );
}

export default Header;
